import { withStyles } from '@material-ui/core';

import PushNotificationPreview from './component';
import styles from './styles';

export default withStyles(styles)(PushNotificationPreview);
